// @ts-nocheck
import { checkboxSizes } from "@insite/mobius/Checkbox";
import { toggleSizes } from "@store/MobiusOverrides/Checkbox/ToggleInput";
import merge from "lodash/merge";

/** checkboxSizes
 * ------------------------------------------------------------------------------------------
 * iconSize: Icon size (px)
 * fontSize: Font size for label (px)
 * borderRadius: Border radius (px)
 *  --- Starter Custom Code
 * borderWidth: Border size (px)
 * boxSpacing: Spacing between the checkbox and the label (px)
 * descriptionSpacing: Spacing between hint & error and field (px)
 * itemSpacing: Spacing inbetween checboxes of a same group (px)
 * offset: Offset to align the checkbox with the label (px)
 * toggleOffset: Offset to align the toggle checkbox with the label (px)
 */

merge(checkboxSizes, {
    default: {
        iconSize: 22, // Icon size (px) // Foundation
        fontSize: 16, // Font size for label (px) // Foundation
        borderRadius: 2, // Border radius (px) // Foundation
        // Starter Custom Code
        borderWidth: 2, // Border size (px)
        boxSpacing: 10, // Spacing between the checkbox and the label (px)
        descriptionSpacing: 7, // Spacing between hint & error and field (px)
        itemSpacing: 10, // Spacing inbetween checboxes of a same group (px)
        offset: 2, // Offset to align the checkbox with the label (px)
        toggleOffset: 2, // Offset to align the toggle checkbox with the label (px)
    },
    small: {
        iconSize: 15, // Foundation
        fontSize: 14,
        borderRadius: 2,
        // Starter Custom Code
        borderWidth: 2,
        boxSpacing: 8,
        descriptionSpacing: 5,
        itemSpacing: 6,
        offset: 2,
        toggleOffset: 2,
    },
});

merge(toggleSizes, {
    default: {
        iconSize: 16,
        circleSize: 12,
        height: 20,
        width: 36,
        uncheckedOffset: -16,
    },
    small: {
        iconSize: 14,
        circleSize: 10,
        height: 16,
        width: 30,
        uncheckedOffset: -15,
    },
});
